import { render } from "./RecommendedSection.vue?vue&type=template&id=a6477db2"
import script from "./RecommendedSection.vue?vue&type=script&lang=js"
export * from "./RecommendedSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__